/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreEditCircleOutline = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zm0 14.914c-3.821 0-6.914-3.093-6.914-6.914S4.179 1.086 8 1.086 14.914 4.179 14.914 8 11.821 14.914 8 14.914z"
    />
    <path
      fill="currentColor"
      d="M12.491 5.595l-2.014-2.014c-.108-.108-.369-.036-.548.143L5.252 8.409c-.021.039-.183.161-.229.312l-.996 2.867a.28.28 0 0 0 .065.308.287.287 0 0 0 .309.061l3.079-1.029c.054-.021.226-.14.265-.176l4.749-4.753a.288.288 0 0 0 0-.405zM5.545 8.961l1.52 1.52-1.849.688-.394-.394.724-1.814z"
    />
  </svg>
);

IconCoreEditCircleOutline.displayName = 'IconCoreEditCircleOutline';

IconCoreEditCircleOutline.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreEditCircleOutline);
IconCoreEditCircleOutline.displayName = 'IconCoreEditCircleOutline';
